import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	async getCommCodes(codeType) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getCampaignList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.cmpnNo !== undefined) {
			queryStr = objectToQuerystring({
				cmpnNo: searchParams.cmpnNo /*캠페인명 */,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/mqy/qlty/campaign/v1/campaigns` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCampaignInfo(param) {
		const cmpnNo = param.cmpnNo;
		return client
			.get(`${BASE_URL}/mqy/qlty/campaign/v1/campaign/cmpnNo/${cmpnNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	async savecampaignInfo({ saveParams }) {
		const cmpnNo = saveParams.cmpnNo;
		try {
			const response = await client.post(`${BASE_URL}/mqy/qlty/campaign/v1/campaign/status/2/cmpnNo/${cmpnNo}`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async deleteCampaignInfo({ cmpnNo, deleteParams }) {
		//console.log('캠페인귀책 삭제 api실행',  cmpnNo , deleteParams);
		try {
			const response = await client.post(`${BASE_URL}/mqy/qlty/campaign/v1/campaign/status/3/cmpnNo/${cmpnNo}`, deleteParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
